
import React, { useEffect } from 'react';
import "../Assets/styles/Services.css"
import ServiceBanShape from "../Assets/Resources/service-ban-shape.png"
import Serviceoneimg from "../Assets/Resources/service-one-1.png"
import RightArrow from "../Assets/Resources/service-right-arrow.svg"
import KeyBenefitsImg from "../Assets/Resources/adobe-benefits-img.png"
import KeyBenefitsImg2 from "../Assets/Resources/adobe-benefits-img-2.png"
import KeyBenefitsImg3 from "../Assets/Resources/adobe-benefits-img-3.png"
import KeyBenefitsImg4 from "../Assets/Resources/adobe-benefits-img-4.png"
import KeyBenefitsImg5 from "../Assets/Resources/adobe-benefits-img-5.png"
import AiDataImage from "../Assets/Resources/ai-data-img.png"
import Logo from "../Assets/Resources/banner-logo.svg";
import Slider from "react-slick";
import gsap from 'gsap'
import ScrollTrigger from 'gsap/ScrollTrigger'
import SplitType from 'split-type'
import AOS from "aos";
import "aos/dist/aos.css";
import ServiceStar from "../Assets/Resources/service-star.svg"
import AllPageLoader from '../Components/AllPageLoader';

const ERP = () => {


    const serSettings = {
        infinite: true,
        arrows: false,
        speed: 500,
        autoplay: true,
        slidesToShow: 3,
        slidesToScroll: 1,
        responsive: [
            {
                breakpoint: 1200, // For screens smaller than 1200px
                settings: {
                    slidesToShow: 5,
                    slidesToScroll: 1,
                }
            },
            {
                breakpoint: 992, // For screens smaller than 992px
                settings: {
                    slidesToShow: 2,
                    slidesToScroll: 1,
                }
            },
            {
                breakpoint: 768, // For screens smaller than 768px
                settings: {
                    slidesToShow: 2,
                    slidesToScroll: 1,
                }
            },
            {
                breakpoint: 576, // For screens smaller than 576px
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1,
                }
            }
        ]
    };




    useEffect(() => {
        gsap.registerPlugin(ScrollTrigger);

        const SplitTypes = document.querySelectorAll('.text-reveal-animation');
        SplitTypes.forEach((char) => {
            const text = new SplitType(char, { types: 'chars' });
            gsap.from(text.chars, {
                scrollTrigger: {
                    trigger: char,
                    start: 'top 80%',
                    end: 'top 20%',
                    scrub: true,
                    markers: false
                },
                scaleY: 0,
                y: -20,
                transformOrigin: 'top',
                stagger: 0.05
            });
        });
    }, []);

    useEffect(() => {
        const SplitTypes = document.querySelectorAll('.ban-title-animation');
        SplitTypes.forEach((char) => {
            const text = new SplitType(char, { types: 'chars' });
            gsap.from(text.chars, {
                opacity: 0.2,
                stagger: 0.08,
                scrub: true,
            });
        });
    }, []);



    useEffect(() => {
        const SplitTypes = document.querySelectorAll('.mini-title-animation');
        SplitTypes.forEach((char) => {
            const text = new SplitType(char, { types: 'chars' });
            gsap.from(text.chars, {
                scrollTrigger: {
                    trigger: char,
                    start: 'top 80%',
                    end: 'top 20%',
                    scrub: true,
                    markers: false
                },
                opacity: 0.2,
                stagger: 0.08,
                scrub: true,
            });
        });
    }, []);


    useEffect(() => {
        gsap.registerPlugin(ScrollTrigger);

        const elements = document.querySelectorAll('.para-animation');
        elements.forEach((element) => {
            gsap.fromTo(
                element,
                { opacity: 0, y: 20 }, // Start with opacity 0 and slightly below the position
                {
                    opacity: 1,        // End with opacity 1 (fully visible)
                    y: 0,              // Move to the original position
                    duration: 1,       // Adjust duration for smoother transition
                    ease: "power2.out", // Smooth easing
                    scrollTrigger: {
                        trigger: element,
                        start: "top 80%",
                        end: "top 20%",
                        scrub: true,    // One-time animation on scroll
                        markers: false,
                    },
                }
            );
        });
    }, []);



    useEffect(() => {
        gsap.registerPlugin(ScrollTrigger);

        const SplitTypes = document.querySelectorAll('.text-reveal-animation');
        SplitTypes.forEach((char) => {
            const text = new SplitType(char, { types: 'chars' });
            gsap.from(text.chars, {
                scrollTrigger: {
                    trigger: char,
                    start: 'top 80%',
                    end: 'top 20%',
                    scrub: true,
                    markers: false
                },
                scaleY: 0,
                y: -20,
                transformOrigin: 'top',
                stagger: 0.05
            });
        });
    }, []);

    useEffect(() => {
        const SplitTypes = document.querySelectorAll('.ban-title-animation');
        SplitTypes.forEach((char) => {
            const text = new SplitType(char, { types: 'chars' });
            gsap.from(text.chars, {
                opacity: 0.2,
                stagger: 0.08,
                scrub: true,
            });
        });
    }, []);



    useEffect(() => {
        const SplitTypes = document.querySelectorAll('.mini-title-animation');
        SplitTypes.forEach((char) => {
            const text = new SplitType(char, { types: 'chars' });
            gsap.from(text.chars, {
                scrollTrigger: {
                    trigger: char,
                    start: 'top 80%',
                    end: 'top 20%',
                    scrub: true,
                    markers: false
                },
                opacity: 0.2,
                stagger: 0.08,
                scrub: true,
            });
        });
    }, []);


    useEffect(() => {
        gsap.registerPlugin(ScrollTrigger);

        const elements = document.querySelectorAll('.para-animation');
        elements.forEach((element) => {
            gsap.fromTo(
                element,
                { opacity: 0, y: 20 }, // Start with opacity 0 and slightly below the position
                {
                    opacity: 1,        // End with opacity 1 (fully visible)
                    y: 0,              // Move to the original position
                    duration: 1,       // Adjust duration for smoother transition
                    ease: "power2.out", // Smooth easing
                    scrollTrigger: {
                        trigger: element,
                        start: "top 80%",
                        end: "top 20%",
                        scrub: true,    // One-time animation on scroll
                        markers: false,
                    },
                }
            );
        });
    }, []);







    return (
        <>
            <AllPageLoader />
            <section className='service-hero-section'>
                <div className="container-fluid common-btn">
                    <div className="row">
                        <div className="banner-content">
                            <h1 className='ban-title-animation'>Prophecy <br />Technologies</h1>
                            <h6 data-aos="fade-down" data-aos-duration="2000" data-aos-delay="500">Your ERP Journey Starts Here: Transform, Adapt, Thrive!</h6>
                            <p data-aos="fade-down" data-aos-duration="2000" data-aos-delay="700">Embarking on your ERP journey with Prophecy Technologies means transforming your
                                business processes into a seamless experience. Empower your organization to adapt to
                                changing demands with tailored ERP solutions designed for efficiency and growth.</p>
                            <a href="/contact">
                                <button data-aos="fade-up" data-aos-duration="2000" data-aos-delay="900">Talk with Our Experts</button>
                            </a>
                        </div>
                    </div>
                </div>
                <div className="service-hero-shape">
                    <img src={ServiceBanShape} alt="" />
                </div>
            </section>


            <div className="gradient-bg">
                <section className='service-section-three gradient-bg sec-padding'>
                    <div className="container">
                        <div className="row">
                            <div className="col-lg-7">
                                <div className="title">
                                    <h6 data-aos="fade-right" data-aos-duration="2000" data-aos-delay="300">What steps are involved in a</h6>
                                    <h1 className='mini-title-animation'>successful <br />ERP <br />implementation?</h1>
                                </div>
                            </div>
                            <div className="col-lg-5">
                                <div className="image" data-aos="fade-left" data-aos-duration="2000" >
                                    <img src={KeyBenefitsImg} alt="" />
                                </div>
                            </div>
                        </div>
                        <p className='para-animation'>At Prophecy Technologies, a successful ERP implementation follows a structured,
                            step-by-step approach, ensuring a smooth transition and maximum value for your
                            organization.</p>
                        <div className="benefit-items">
                            <div className="row">
                                <Slider  {...serSettings} className='serSlideItems'>
                                    <div className='serSlide'>
                                        <div className="item" data-aos="fade-up" data-aos-duration="2000" >
                                            <div className="icon">
                                                <img src={ServiceStar} alt="" />
                                            </div>
                                            <div className="content">
                                                <h6>1. Define Project Goals and Scope</h6>
                                                <p>We start by defining the ERP project’s goals and scope, aligning it with your business
                                                    objectives to ensure that the system meets all critical requirements.
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                    <div className='serSlide'>
                                        <div className="item" data-aos="fade-up" data-aos-duration="2000" data-aos-delay="300">
                                            <div className="icon">
                                                <img src={ServiceStar} alt="" />
                                            </div>
                                            <div className="content">
                                                <h6>2. Select the Right ERP Solution
                                                </h6>
                                                <p>Our experts work with you to select the ERP platform best suited to your industry and
                                                    operational needs, ensuring long-term scalability and support.
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                    <div className='serSlide'>
                                        <div className="item" data-aos="fade-up" data-aos-duration="2000" data-aos-delay="500">
                                            <div className="icon">
                                                <img src={ServiceStar} alt="" />
                                            </div>
                                            <div className="content">
                                                <h6>3. Form an Implementation Team</h6>
                                                <p>We establish a dedicated team of stakeholders, IT professionals, and ERP specialists to
                                                    oversee the implementation process and facilitate communication.
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                    <div className='serSlide'>
                                        <div className="item" data-aos="fade-up" data-aos-duration="2000" data-aos-delay="500">
                                            <div className="icon">
                                                <img src={ServiceStar} alt="" />
                                            </div>
                                            <div className="content">
                                                <h6>4. Conduct Data Migration and Cleansing</h6>
                                                <p>Our team manages data migration by transferring and cleansing data from legacy
                                                    systems, ensuring it’s accurate, complete, and ready for the new ERP</p>
                                            </div>
                                        </div>
                                    </div>
                                    <div className='serSlide'>
                                        <div className="item" data-aos="fade-up" data-aos-duration="2000" data-aos-delay="500">
                                            <div className="icon">
                                                <img src={ServiceStar} alt="" />
                                            </div>
                                            <div className="content">
                                                <h6>5. Customize and Configure the ERP System</h6>
                                                <p>We tailor the ERP system to fit your specific workflows, setting up features, permissions,
                                                    and integrations to align with your business processes</p>
                                            </div>
                                        </div>
                                    </div>
                                    <div className='serSlide'>
                                        <div className="item" data-aos="fade-up" data-aos-duration="2000" data-aos-delay="500">
                                            <div className="icon">
                                                <img src={ServiceStar} alt="" />
                                            </div>
                                            <div className="content">
                                                <h6>6. Set Up Testing and Quality Assurance</h6>
                                                <p>Comprehensive testing is conducted to validate that all ERP functionalities work as
                                                    expected and to identify and resolve issues before go-live.
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                    <div className='serSlide'>
                                        <div className="item" data-aos="fade-up" data-aos-duration="2000" data-aos-delay="500">
                                            <div className="icon">
                                                <img src={ServiceStar} alt="" />
                                            </div>
                                            <div className="content">
                                                <h6>7. Monitor and Support Post-Go-Live</h6>
                                                <p>Following go-live, we offer ongoing support, monitoring system performance,
                                                    addressing issues, and optimizing features based on user feedback.</p>
                                            </div>
                                        </div>
                                    </div>
                                    <div className='serSlide'>
                                        <div className="item" data-aos="fade-up" data-aos-duration="2000" data-aos-delay="500">
                                            <div className="icon">
                                                <img src={ServiceStar} alt="" />
                                            </div>
                                            <div className="content">
                                                <h6>8. Conduct Continuous Optimization and Updates</h6>
                                                <p>We provide continuous improvements and updates, adapting the ERP system as your
                                                    business grows and evolves to maintain optimal performance.</p>
                                            </div>
                                        </div>
                                    </div>
                                </Slider>
                                <p className='para-animation'>Prophecy Technologies’ methodical ERP implementation process ensures a successful
                                    deployment that enhances operational efficiency and supports your business growth
                                </p>
                                <a href="/contact" className='common-btn service-large-btn center-ser-btn'>
                                    <button data-aos="fade-up" data-aos-duration="2000" data-aos-delay="900">Get Started With Us Now!
                                    </button>
                                </a>
                            </div>
                        </div>
                    </div>
                    <div className="gradient-bg-radial-1"></div>
                    <div className="gradient-bg-radial-2"></div>
                </section>
            </div>


            <section className='service-section-three no-gradient-bg sec-padding'>
                <div className="container">
                    <div className="row">
                        <div className="col-lg-5">
                            <div className="image" data-aos="fade-right" data-aos-duration="2000" data-aos-delay="500">
                                <img src={KeyBenefitsImg2} alt="" />
                            </div>
                        </div>
                        <div className="col-lg-7">
                            <div className="title">
                                <h6 data-aos="fade-left" data-aos-duration="2000" data-aos-delay="500">How does ERP Improve</h6>
                                <h1 className='mini-title-animation'>Data <br />Management &<br /> Reporting?</h1>
                            </div>
                        </div>
                    </div>
                    <p className='para-animation'>Prophecy Technologies’ ERP solutions enhance data management and reporting,
                        streamlining access to accurate information and enabling better decision-making.</p>
                    <div className="benefit-items">
                        <div className="row">
                            <Slider  {...serSettings} className='serSlideItems'>
                                <div className='serSlide'>
                                    <div className="item" data-aos="fade-up" data-aos-duration="2000" >
                                        <div className="icon">
                                            <img src={ServiceStar} alt="" />
                                        </div>
                                        <div className="content">
                                            <h6>1. Centralized Data Storage</h6>
                                            <p>ERP consolidates data from multiple sources into a single, unified platform, eliminating
                                                silos and providing a single source of truth for the entire organization.
                                            </p>
                                        </div>
                                    </div>
                                </div>
                                <div className='serSlide'>
                                    <div className="item" data-aos="fade-up" data-aos-duration="2000" data-aos-delay="300">
                                        <div className="icon">
                                            <img src={ServiceStar} alt="" />
                                        </div>
                                        <div className="content">
                                            <h6>2. Improved Data Accuracy</h6>
                                            <p>With automated data entry and validation, ERP systems reduce human error, ensuring
                                                data is accurate, reliable, and up-to-date.</p>
                                        </div>
                                    </div>
                                </div>
                                <div className='serSlide'>
                                    <div className="item" data-aos="fade-up" data-aos-duration="2000" data-aos-delay="500">
                                        <div className="icon">
                                            <img src={ServiceStar} alt="" />
                                        </div>
                                        <div className="content">
                                            <h6>3. Real-Time Data Access</h6>
                                            <p>ERP enables real-time data access, allowing teams to make timely, informed decisions
                                                based on the latest information across all departments</p>
                                        </div>
                                    </div>
                                </div>
                                <div className='serSlide'>
                                    <div className="item" data-aos="fade-up" data-aos-duration="2000" data-aos-delay="500">
                                        <div className="icon">
                                            <img src={ServiceStar} alt="" />
                                        </div>
                                        <div className="content">
                                            <h6>4. Enhanced Data Security and Compliance</h6>
                                            <p>Our ERP solutions include robust security features and compliance tools, protecting
                                                sensitive information and ensuring regulatory adherence.</p>
                                        </div>
                                    </div>
                                </div>
                                <div className='serSlide'>
                                    <div className="item" data-aos="fade-up" data-aos-duration="2000" data-aos-delay="500">
                                        <div className="icon">
                                            <img src={ServiceStar} alt="" />
                                        </div>
                                        <div className="content">
                                            <h6>5. Customizable Dashboards and Visualizations</h6>
                                            <p>With customizable dashboards, users can view data visualizations tailored to their
                                                needs, making complex data easy to interpret and act upon.</p>
                                        </div>
                                    </div>
                                </div>
                                <div className='serSlide'>
                                    <div className="item" data-aos="fade-up" data-aos-duration="2000" data-aos-delay="500">
                                        <div className="icon">
                                            <img src={ServiceStar} alt="" />
                                        </div>
                                        <div className="content">
                                            <h6>6. Better Forecasting and Insights</h6>
                                            <p>ERP systems offer predictive analytics and forecasting, enabling leaders to anticipate
                                                trends and make proactive business decisions.</p>
                                        </div>
                                    </div>
                                </div>
                                <div className='serSlide'>
                                    <div className="item" data-aos="fade-up" data-aos-duration="2000" data-aos-delay="500">
                                        <div className="icon">
                                            <img src={ServiceStar} alt="" />
                                        </div>
                                        <div className="content">
                                            <h6>7. Reduced Redundancy and Duplication
                                            </h6>
                                            <p>By consolidating data, ERP reduces duplication, ensuring that everyone works with the
                                                same information and improves reporting accuracy.
                                            </p>
                                        </div>
                                    </div>
                                </div>
                                <div className='serSlide'>
                                    <div className="item" data-aos="fade-up" data-aos-duration="2000" data-aos-delay="500">
                                        <div className="icon">
                                            <img src={ServiceStar} alt="" />
                                        </div>
                                        <div className="content">
                                            <h6>8. Enhanced Collaboration Across Teams</h6>
                                            <p>Centralized data fosters collaboration, allowing cross-departmental teams to access
                                                shared data and work together more efficiently.</p>
                                        </div>
                                    </div>
                                </div>
                            </Slider>
                        </div>
                    </div>
                </div>
            </section>



            <div className="gradient-bg">
                <section className='service-section-three gradient-bg sec-padding'>
                    <div className="container">
                        <div className="row">
                            <div className="col-lg-7">
                                <div className="title">
                                    <h1 className='mini-title-animation'>Key Features <br />To Look <br />Out For</h1>
                                </div>
                            </div>
                            <div className="col-lg-5">
                                <div className="image" data-aos="fade-left" data-aos-duration="2000" >
                                    <img src={KeyBenefitsImg3} alt="" />
                                </div>
                            </div>
                        </div>
                        <p className='para-animation'>When selecting an ERP solution, key features ensure the system aligns with your
                            business needs and drives efficiency across your organization</p>
                        <div className="benefit-items">
                            <div className="row">
                                <Slider  {...serSettings} className='serSlideItems'>
                                    <div className='serSlide'>
                                        <div className="item" data-aos="fade-up" data-aos-duration="2000" >
                                            <div className="icon">
                                                <img src={ServiceStar} alt="" />
                                            </div>
                                            <div className="content">
                                                <h6>1. Customizable Dashboards and User Interface</h6>
                                                <p>An ERP with customizable dashboards lets users personalize their view, streamlining
                                                    access to the most relevant information and workflows.</p>
                                            </div>
                                        </div>
                                    </div>
                                    <div className='serSlide'>
                                        <div className="item" data-aos="fade-up" data-aos-duration="2000" data-aos-delay="300">
                                            <div className="icon">
                                                <img src={ServiceStar} alt="" />
                                            </div>
                                            <div className="content">
                                                <h6>2. Real-Time Data Access and Analytics
                                                </h6>
                                                <p>Real-time data enables accurate decision-making, providing insights into performance,
                                                    financials, and operations without delays.</p>
                                            </div>
                                        </div>
                                    </div>
                                    <div className='serSlide'>
                                        <div className="item" data-aos="fade-up" data-aos-duration="2000" data-aos-delay="500">
                                            <div className="icon">
                                                <img src={ServiceStar} alt="" />
                                            </div>
                                            <div className="content">
                                                <h6>3. Robust Integration Capabilities</h6>
                                                <p>A strong ERP integrates seamlessly with other tools, such as CRM, HR, and finance
                                                    software, centralizing data and simplifying workflows.
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                    <div className='serSlide'>
                                        <div className="item" data-aos="fade-up" data-aos-duration="2000" data-aos-delay="500">
                                            <div className="icon">
                                                <img src={ServiceStar} alt="" />
                                            </div>
                                            <div className="content">
                                                <h6>4. Comprehensive Reporting Tools</h6>
                                                <p>Look for advanced reporting features that offer customizable templates and automated
                                                    generation, saving time and ensuring data accuracy</p>
                                            </div>
                                        </div>
                                    </div>
                                    <div className='serSlide'>
                                        <div className="item" data-aos="fade-up" data-aos-duration="2000" data-aos-delay="500">
                                            <div className="icon">
                                                <img src={ServiceStar} alt="" />
                                            </div>
                                            <div className="content">
                                                <h6>5. Mobile Accessibility</h6>
                                                <p>Mobile ERP capabilities allow users to access critical data on the go, enabling flexibility
                                                    and efficiency outside the office.
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                    <div className='serSlide'>
                                        <div className="item" data-aos="fade-up" data-aos-duration="2000" data-aos-delay="500">
                                            <div className="icon">
                                                <img src={ServiceStar} alt="" />
                                            </div>
                                            <div className="content">
                                                <h6>6. Scalable Infrastructure
                                                </h6>
                                                <p>A scalable ERP grows with your business, adapting to increased users, data, and
                                                    processes without losing performance.
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                    <div className='serSlide'>
                                        <div className="item" data-aos="fade-up" data-aos-duration="2000" data-aos-delay="500">
                                            <div className="icon">
                                                <img src={ServiceStar} alt="" />
                                            </div>
                                            <div className="content">
                                                <h6>7. Strong Data Security and Compliance</h6>
                                                <p>Top ERPs come with built-in security measures and compliance support, protecting your
                                                    data and helping you meet regulatory requirements.
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                    <div className='serSlide'>
                                        <div className="item" data-aos="fade-up" data-aos-duration="2000" data-aos-delay="500">
                                            <div className="icon">
                                                <img src={ServiceStar} alt="" />
                                            </div>
                                            <div className="content">
                                                <h6>8. Workflow Automation</h6>
                                                <p>Automation in ERP systems reduces manual tasks, speeds up operations, and
                                                    minimizes errors across repetitive business processes.</p>
                                            </div>
                                        </div>
                                    </div>

                                </Slider>
                                <p className='para-animation'>Prophecy Technologies helps you choose an ERP solution with the key features that
                                    drive operational success and support long-term growth.</p>
                                <a href="/contact" className='common-btn service-large-btn service-mega-btn'>
                                    <button data-aos="fade-up" data-aos-duration="2000" data-aos-delay="900">Take the First Step with Prophecy Now!</button>
                                </a>
                            </div>
                        </div>
                    </div>
                    <div className="gradient-bg-radial-1"></div>
                    <div className="gradient-bg-radial-2"></div>
                </section>
            </div>


            <section className='service-section-three no-gradient-bg sec-padding'>
                <div className="container">
                    <div className="row">
                        <div className="col-lg-5">
                            <div className="image" data-aos="fade-right" data-aos-duration="2000" data-aos-delay="500">
                                <img src={KeyBenefitsImg2} alt="" />
                            </div>
                        </div>
                        <div className="col-lg-7">
                            <div className="title">
                                <h6 data-aos="fade-down" data-aos-duration="2000" data-aos-delay="300">Elevate Your Enterprise:</h6>
                                <h1 className='mini-title-animation'>Tools for <br />Effective ERP<br />Deployment</h1>
                            </div>
                        </div>
                    </div>
                    <p className='para-animation'>Prophecy Technologies equips your enterprise with the right tools for a successful ERP
                        deployment, leveraging industry-leading platforms to maximize efficiency.
                    </p>
                    <div className="benefit-items">
                        <div className="row">
                            <Slider  {...serSettings} className='serSlideItems'>
                                <div className='serSlide'>
                                    <div className="item" data-aos="fade-up" data-aos-duration="2000" >
                                        <div className="icon">
                                            <img src={ServiceStar} alt="" />
                                        </div>
                                        <div className="content">
                                            <h6>1. SAP: Comprehensive Enterprise Management</h6>
                                            <p>SAP ERP offers robust tools for managing complex business processes, providing
                                                features like advanced analytics, resource planning, and integrated workflows</p>
                                        </div>
                                    </div>
                                </div>
                                <div className='serSlide'>
                                    <div className="item" data-aos="fade-up" data-aos-duration="2000" data-aos-delay="300">
                                        <div className="icon">
                                            <img src={ServiceStar} alt="" />
                                        </div>
                                        <div className="content">
                                            <h6>2. Oracle: Scalable and Secure Solutions</h6>
                                            <p>Oracle ERP delivers secure, cloud-based solutions with scalability, ensuring your
                                                system can adapt to growing data needs and provide real-time insights.
                                            </p>
                                        </div>
                                    </div>
                                </div>
                                <div className='serSlide'>
                                    <div className="item" data-aos="fade-up" data-aos-duration="2000" data-aos-delay="500">
                                        <div className="icon">
                                            <img src={ServiceStar} alt="" />
                                        </div>
                                        <div className="content">
                                            <h6>3. Microsoft Dynamics 365: Flexible and User-Friendly</h6>
                                            <p>Dynamics 365 combines ERP and CRM capabilities, enabling seamless integration
                                                across departments and delivering an intuitive, customizable interface.
                                            </p>
                                        </div>
                                    </div>
                                </div>
                                <div className='serSlide'>
                                    <div className="item" data-aos="fade-up" data-aos-duration="2000" data-aos-delay="500">
                                        <div className="icon">
                                            <img src={ServiceStar} alt="" />
                                        </div>
                                        <div className="content">
                                            <h6>4. NetSuite: Cloud ERP for Growing Enterprises</h6>
                                            <p>NetSuite’s cloud-native ERP is ideal for growing businesses, offering financial, CRM,
                                                and eCommerce tools that are accessible from anywhere.
                                            </p>
                                        </div>
                                    </div>
                                </div>
                                <div className='serSlide'>
                                    <div className="item" data-aos="fade-up" data-aos-duration="2000" data-aos-delay="500">
                                        <div className="icon">
                                            <img src={ServiceStar} alt="" />
                                        </div>
                                        <div className="content">
                                            <h6>5. Customizable Reporting and Analytics</h6>
                                            <p>Robust reporting tools within your ERP allow for customizable dashboards and reports,
                                                turning raw data into actionable insights with ease.</p>
                                        </div>
                                    </div>
                                </div>
                                <div className='serSlide'>
                                    <div className="item" data-aos="fade-up" data-aos-duration="2000" data-aos-delay="500">
                                        <div className="icon">
                                            <img src={ServiceStar} alt="" />
                                        </div>
                                        <div className="content">
                                            <h6>6. Ongoing Monitoring and Optimization Tools</h6>
                                            <p>Post-deployment, our monitoring tools ensure optimal performance, with continuous
                                                optimization to align with evolving business requirements.</p>
                                        </div>
                                    </div>
                                </div>

                            </Slider>
                            <a href="/contact" className='common-btn service-large-btn service-mega-btn'>
                                <button data-aos="fade-up" data-aos-duration="2000" data-aos-delay="900">Contact Us To Get Started</button>
                            </a>
                        </div>
                    </div>
                </div>
            </section>




            <section className='cta-section common-btn sec-padding service-page-cta'>
                <div className="container">
                    <div className="row">
                        <div className="sec-title">
                            <div className="large-title">
                                <h1 className='mini-title-animation'>Navigate Your <br />ERP Journey</h1>
                            </div>
                            <p data-aos="fade-up" data-aos-duration="2000">Chart a path to ERP success with expert guidance from Prophecy Technologies.
                                We provide customized strategies and in-depth support to make your ERP
                                transformation smooth and impactful.
                            </p>
                            <a href="/contact" className='common-btn service-large-btn'>
                                <button data-aos="fade-up" data-aos-duration="2000" data-aos-delay="900">Connect With Experts Now!
                                </button>
                            </a>
                        </div>
                    </div>
                </div>
            </section>


        </>
    )
}

export default ERP